import { Button } from "@/components/ui/button";
import { EmptyState } from "@/components/ui/empty-state";
import * as Sentry from "@sentry/react";
import { Box, Text } from "@chakra-ui/react";
import { LuTriangleAlert } from "react-icons/lu";
import { NavLink, useRouteError } from "react-router-dom";

const Error = () => {
  const error = useRouteError();
  console.error(error);
  Sentry.captureException(error);

  return (
    <EmptyState icon={<LuTriangleAlert />} title="Something went wrong" size="lg">
      <Box textAlign="center" display="flex" flexDirection="column" alignItems="center" gap={4}>
        <Text fontSize="md" color="gray.600" lineHeight="1.6" maxW="md">
          This page couldn't load. We've been notified. Try refreshing, or head back to your trips.
        </Text>
        <Button as={NavLink} to="/trips" tone="primary" size="md" borderRadius="xl">
          Back to Trips
        </Button>
      </Box>
    </EmptyState>
  );
};
export default Error;
